import { useTheme } from "@emotion/react";
import useStyles from "./styles";
import { Box } from "@mui/system";
import { Avatar, Chip, Paper, Typography } from "@mui/material";
import { StarOutlineOutlined } from "@mui/icons-material";
import dayjs from "dayjs";
import StyledRatingComponent from "../../styledRatingComponent";
export default function AnswerQuestionsComponent(params) {
	const { ticketDetails = [] } = params;

	const theme = useTheme();
	const styles = useStyles(theme);

	return (
		<>
			<Box sx={styles.boxEdit}>
				<Typography sx={styles.titleDescription}>
					<StarOutlineOutlined sx={{ fontSize: "18px" }} />
					Avaliação
				</Typography>
			</Box>
			<Box sx={styles.containerBodyModal}>
				<Box sx={styles.boxBodyModal}>
					<Paper
						variant="outlined"
						elevation={0}
						sx={styles.containerPaperModal}
					>
						<Box sx={styles.containerBodyAnswer}>
							<Typography sx={{ fontWeight: "bold" }}>Avaliado por:</Typography>
							<Typography sx={{ fontWeight: "bold", fontSize: "15px" }}>
								{dayjs(
									ticketDetails?.avaliacao?.[0]?.answers?.[0]?.createAt
								).format("DD/MM/YYYY") || "Sem dados"}
							</Typography>
						</Box>

						<Box sx={styles.containerInfoClient}>
							<Avatar
								src={ticketDetails?.avaliacao?.[0]?.userClient?.foto}
								sx={{
									color: theme.palette.white.main,
									bgcolor: theme.palette.secondary.dark,
								}}
							/>
							<Typography>
								{ticketDetails?.avaliacao?.[0]?.userClient?.nome +
									" " +
									ticketDetails?.avaliacao?.[0]?.userClient?.sobrenome ||
									"Sem dados"}
							</Typography>
						</Box>
						{ticketDetails?.avaliacao?.map((avaliacao, index) => (
							<Paper variant="outlined" sx={styles.containerAnswer}>
								<Typography>
									{index + 1} - {avaliacao?.question}
								</Typography>
								<Box sx={styles.boxAnswer}>
									{avaliacao?.answers?.map((answer) => (
										<Box>
											{avaliacao?.type === 0 && (
												<Box>
													{answer?.answer ? (
														<StyledRatingComponent
															valueDefault={answer?.answer}
														/>
													) : (
														<Typography sx={styles.descriptionAvaliacao}>
															Sem avaliação
														</Typography>
													)}
												</Box>
											)}
											{avaliacao?.type === 1 && (
												<Box>
													{answer?.answer ? (
														<Typography sx={{ textAlign: "justify" }}>
															{answer?.answer}{" "}
														</Typography>
													) : (
														<Typography sx={styles.descriptionAvaliacao}>
															Sem avaliação
														</Typography>
													)}
												</Box>
											)}
											{avaliacao?.type === 2 && (
												<Box>
													{answer?.answer ? (
														<Chip size="small" label={answer?.answer} />
													) : (
														<Typography sx={styles.descriptionAvaliacao}>
															Sem avaliação
														</Typography>
													)}
												</Box>
											)}
										</Box>
									))}
									{avaliacao?.type === 2 &&
										avaliacao?.answers?.length === 0 && (
											<Typography sx={styles.descriptionAvaliacao}>
												Sem avaliação
											</Typography>
										)}
								</Box>
							</Paper>
						))}
					</Paper>
				</Box>
			</Box>
		</>
	);
}
